module["exports"] = {
  "adjective": [
    "Pequeno",
    "Ergonômico",
    "Rústico",
    "Inteligente",
    "Lindo",
    "Incrível",
    "Fantástico",
    "Prático",
    "Lustroso",
    "Impressionante",
    "Genérico",
    "Feito à mão",
    "Licenciado",
    "Refinado",
    "Sem marca",
    "Gostoso"
  ],
  "material": [
    "Aço",
    "Madeira",
    "Concreto",
    "Plástico",
    "Algodão",
    "Granito",
    "Borracha",
    "Metal",
    "Macio",
    "Fresco",
    "Congelado"
  ],
  "product": [
    "Cadeira",
    "Carro",
    "Computador",
    "Teclado",
    "Mouse",
    "Bicicleta",
    "Bola",
    "Luvas",
    "Calças",
    "Camiseta",
    "Mesa",
    "Sapatos",
    "Chapéu",
    "Toalhas",
    "Sabonete",
    "Atum",
    "Frango",
    "Peixe",
    "Queijo",
    "Bacon",
    "Pizza",
    "Salada",
    "Salsicha",
    "Salgadinhos"
  ]
};
